import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Container } from '../../components/layout/ContainerFlex';
import { ScreenTitle } from '../../components/layout/ScreenTitle';
import { getImportHelpers } from '../../customQuery/SqlHelperSelector';
import CodeSnippet from '../../helpContext/CodeSnippet';
import HelpContainer from '../../helpContext/HelpContainer';
import { importJob } from '../store/import.state';

export type ImportTransformPanelProps = {
  children?: React.ReactNode;
  className?: string;
  importJobId?: string;
};

export const ImportTransformPanel = ({
  children,
  className,
  importJobId: propImportJobId,
}: ImportTransformPanelProps) => {
  const [id] = useState<string>(_.uniqueId());
  const { t } = useTranslation('importer');
  const currentImportJob = useRecoilValue(importJob);

  // Get SQL helpers for this import job
  const helpers = getImportHelpers(propImportJobId || currentImportJob?.id);

  console.log('helpers', helpers);
  return (
    <Container hasOverflowY flex1 col>
      <ScreenTitle
        isSticky
        title={t`Transform and Enrich`}
        subtitle={t`Data Import`}
        hasStepCounter={'3.'}
      />
      <HelpContainer id={'importer/transform-intro'} hasPadding />
      <HelpContainer id={'importer/transform-helper'} hasPadding />
      {/* Render SQL helpers as callouts */}
      {helpers.map((helper, index) => (
        <div className="p-4" key={`${helper.label}-${index}`}>
          <CodeSnippet title={helper.label} canCopy>
            {helper.value}
          </CodeSnippet>
        </div>
      ))}

      {children}
    </Container>
  );
};
